module.exports = __webpack_public_path__ + "static/media/view1.0d0d7369.jpg";